<button mat-icon-button type="button" (click)="loadPicker()">
  <mat-icon>add_to_drive</mat-icon>
</button>
